import React, { createContext, useContext, useState, ReactNode } from 'react'
import { UyapSession } from '../../types'
import axios from 'axios'
import { useSnackbar } from 'notistack'

interface SessionContextType {
  sessions: UyapSession[]
  sessionLoading: boolean
  fetchSessions: () => Promise<void>
  setCookie: (sessionId: string) => Promise<void>
}

const SessionContext = createContext<SessionContextType | undefined>(undefined)

export const SessionProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [sessions, setSessions] = useState<UyapSession[]>([])
  const [sessionLoading, setSessionLoading] = useState(false)
  const { enqueueSnackbar } = useSnackbar()

  const fetchSessions = async () => {
    try {
      const { data } = await axios.get('/sessions', {
        withCredentials: true,
      })

      setSessions(data)
    } catch (error) {
      console.error('Failed to fetch sessions:', error)
    }
  }

  const setCookie = async (sessionId: string) => {
    setSessionLoading(true)
    try {
      const response = await axios.get(`/sessions/${sessionId}`, {
        withCredentials: true,
      })

      if (!response.data.status) throw new Error('Failed to set cookie.')

      localStorage.setItem('loginState', 'true')
      enqueueSnackbar("Cookie başarıyla ayarlandı! UYAP'ı açabilirsiniz.", {
        variant: 'success',
      })
    } catch (error) {
      console.error('Failed to set cookie:', error)
      await fetchSessions()
      enqueueSnackbar('Cookie ayarlanamadı.', { variant: 'error' })
      throw error
    } finally {
      setSessionLoading(false)
    }
  }

  const contextValue: SessionContextType = {
    sessions,
    sessionLoading,
    fetchSessions,
    setCookie,
  }

  return (
    <SessionContext.Provider value={contextValue}>
      {children}
    </SessionContext.Provider>
  )
}

export const useSessionContext = () => {
  const context = useContext(SessionContext)
  if (context === undefined) {
    throw new Error('useSessionContext must be used within a SessionProvider')
  }
  return context
}
